import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component, PureComponent, createElement, createContext, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import { adapter, pageRendererFactory, componentRendererFactory, blockRendererFactory, addonRendererFactory, tempRendererFactory, rendererFactory } from '@alilc/lowcode-renderer-core';
import ConfigProvider from '@alifd/next/lib/config-provider';
window.React = React;
window.ReactDom = ReactDOM;
adapter.setRuntime({
  Component: Component,
  PureComponent: PureComponent,
  createContext: createContext,
  createElement: createElement,
  forwardRef: forwardRef,
  findDOMNode: ReactDOM.findDOMNode
});
adapter.setRenderers({
  PageRenderer: pageRendererFactory(),
  ComponentRenderer: componentRendererFactory(),
  BlockRenderer: blockRendererFactory(),
  AddonRenderer: addonRendererFactory(),
  TempRenderer: tempRendererFactory(),
  DivRenderer: blockRendererFactory()
});
adapter.setConfigProvider(ConfigProvider);

function factory() {
  var Renderer = rendererFactory();
  return /*#__PURE__*/function (_Renderer) {
    _inheritsLoose(ReactRenderer, _Renderer);

    function ReactRenderer(props, context) {
      var _this;

      _this = _Renderer.call(this, props, context) || this;
      _this.props = void 0;
      _this.context = void 0;
      _this.setState = void 0;
      _this.forceUpdate = void 0;
      _this.refs = void 0;
      return _this;
    }

    var _proto = ReactRenderer.prototype;

    _proto.isValidComponent = function isValidComponent(obj) {
      var _obj$prototype;

      return (obj === null || obj === void 0 ? void 0 : (_obj$prototype = obj.prototype) === null || _obj$prototype === void 0 ? void 0 : _obj$prototype.isReactComponent) || (obj === null || obj === void 0 ? void 0 : obj.prototype) instanceof Component;
    };

    return ReactRenderer;
  }(Renderer);
}

export default factory();